<template>
  <v-row align="center">
    <v-col>
      <div class="caption">
        {{ displayText }}
      </div>
      <div>
        <v-chip
          label
          x-small
          color="grey--text"
          class="font-weight-bold"
        >
          {{ data.componentType }}
        </v-chip>
      </div>
    </v-col>
    <v-col class="text-right">
      <v-btn
        v-if="enableSettings"
        icon
        color="success"
        small
        @click="$emit('editSettings', data)"
      >
        <v-icon small>
          mdi-cog
        </v-icon>
      </v-btn>

      <v-btn
        icon
        color="success"
        small
        @click="$emit('edit', data)"
      >
        <v-icon small>
          mdi-palette-swatch
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { formatText, checkEnabledSettings } from "./templateHelper/Helper.js";
export default {
    name: "TemplateLine",
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        displayText() {
            const c = this.data;
            return formatText(c.label, c.text, c.componentType);
        },
        enableSettings() {
          return checkEnabledSettings(this.data.componentType);
        }
    }
};
</script>